import GatewayBase from './gatewayBase'
import IQueries from './queries/index'
import QueriesCli from './queries/QueriesCli'
import IAuth from './auth/index'
import AuthNats from './auth/nats'

export default class Api {
    constructor(config) {
        this.config = config
        this.authorised = false
        this.token = null

        if (!config.gateway) {
            throw new Error("config.gateway not set")
        }
        /** @type {GatewayBase} */
        this.gateway = new GatewayBase()
        this.gateway.setAddress(config.gateway)

        /** @type {IQueries} */
        //this.queries = new QueriesPgAliasCli(this.gateway)
        this.queries = new QueriesCli(this.gateway)

        /** @type {IAuth} */
        this.auth = null
        this.auth = new AuthNats(this.gateway)
    }

    setToken(newToken) {
        this.token = newToken
        this.gateway.setToken(newToken)
    }

    async login(login, password) {
        let newToken = await this.auth.login(login, password)
        console.log("newToken",newToken)
        this.setToken(newToken)
    }

    async logout() {
        this.auth.logout().then(()=>{})
        this.setToken(null)
    }
}